import * as React from 'react';
import { connect } from 'react-redux';
import OnlineJourneySelect from '../OnlineJourney/OnlineJourneySelect';
import './GetCover.css';

class GetCover extends React.Component<any, any> {
    public render() {
        return (
            <div className="mt-4">
                <p className="Get-cover font-weight-bold mb-lg-3">Get cover</p>
                <div className="getCover">
                    <div className="container">
                        <OnlineJourneySelect />
                    </div>
                </div>
            </div>
        )
    }
}
export default connect()(GetCover);